import * as React from 'react';

export function useAfterAsyncDomUpdate(trigger, deps, effect, options = {}) {
    const { waitForPaint = false } = options;

    const shouldRunRef = React.useRef(false);
    const prevDepsRef = React.useRef(deps);

    const run = React.useCallback(async () => {
        shouldRunRef.current = true;
        prevDepsRef.current = deps;

        await trigger();
    }, [trigger, deps]);

    React.useEffect(() => {
        const depsChanged =
            deps?.length !== prevDepsRef.current?.length || deps?.some((d, i) => d !== prevDepsRef.current[i]);

        if (shouldRunRef.current && depsChanged) {
            shouldRunRef.current = false;
            prevDepsRef.current = deps;

            if (waitForPaint) {
                requestAnimationFrame(effect);
            } else {
                effect();
            }
        }
    }, deps); // intentionally only deps

    return run;
}

